import { Component, ViewChild, OnInit, Input } from '@angular/core';
import { CountdownComponent } from '../countdown.component/countdown.component';
import { LotteryService } from 'src/app/services';

@Component({
    selector: 'app-countdown-next-draw',
    templateUrl: 'countdown-next-draw-component.html',
    styleUrls: ['./countdown-next-draw.component.scss']
})
export class CountdownNextDrawComponent implements OnInit
{
    @ViewChild('countdown', { static: true }) public countDown: CountdownComponent;

    @Input('showHeadings') public showHeadings: boolean;

    @Input('showAllCountdownBlocks') public showAllCountdownBlocks: boolean;
    
    @Input('useAlternate') public useAlternate: boolean;
    
    @Input('makeFlex') public makeFlex: boolean;

    @Input('yellowTiles') public yellowTiles: boolean;

    public t: Date;

    private readonly lotteryService: LotteryService;

    public constructor(lotteryService: LotteryService)
    {
        this.lotteryService = lotteryService;
    }

    public ngOnInit(): void
    {
        this.lotteryService.getNextDrawDate().subscribe((drawDate) => {
            this.t = drawDate;
        });
    }

    public timeIsUp(): void
    {

    }
}
